import clsx from "clsx";
import React from "react";
import "./settingsFormSection.scss";

interface ISettingsFormSectionProps extends React.ComponentPropsWithoutRef<"div"> { }
export const SettingsFormSection = (props: ISettingsFormSectionProps) => {
    return <div {...props} className={clsx("settings-form-section", props.className)} />;
};
